import React, { CSSProperties, useEffect, useState } from 'react'
import { ChainId, JSBI, TokenAmount } from '@yetiswap/sdk'
import { NavLink, Redirect, useLocation } from 'react-router-dom'
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import { ReactComponent as ForkIcon } from '../../../../assets/svg/git-fork.svg'
import { ReactComponent as AlertIcon } from '../../../../assets/svg/alert.svg'
import { YTS,BOBA, MARKET_PLACE_ADDRESS, ZERO_ADDRESS } from '../../../../constants'
import { useActiveWeb3React } from '../../../../hooks'
import { useApproveCallback } from '../../../../hooks/useApproveCallback'
import { useGetNFTPrice, useGetSaleTokenItem, useGetYetiswapMarketCreatorRate, useBuyNFTToken, useBuyNFTTokenWithAvax, getNFTPrice } from '../../../../hooks/useNFTMarketPlace'
import { useGetCreators, useGetCreatorFeeRate } from '../../../../hooks/useYetiSwapNFTCollection'
import { getTokenPrice } from '../../../../services/NFTMarketPlace/ApiCall'
import { useAddPopup } from '../../../../state/application/hooks'
import NFTCategoryButton from '../../components/NFTCategoryButton'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import { NFTDetailItemWrapper, NFTDetailItem, NFTDetailItemMeta } from '../../components/NFTDetail/syled'
import NFTDetailActions from '../../components/NFTDetailActions'
import NFTPlayAudio from '../../components/NFTPlayAudio/NFTPlayAudio'
import NFTPriceSymbol from '../../components/NFTPriceSymbol'
import NFTRemoveModal from '../../components/NFTRemoveModal'
import NFTUrl from '../../components/NFTUrl'
import NFTUserInfoCompact from '../../components/NFTUserInfoCompact'
import CategoryList from '../../data/NFTCategoryList'
import CollectionList from '../../data/NFTCollectionsList'
import INFTCategory from '../../models/INFTCategory'
import INFTProperties from '../../models/INFTProperties'
import IPriceInfo from '../../models/IPriceInfo'
import { NFTBuyCallBackHandle } from '../../utils/NFTErrorHandleHelper'
import { getSaleToken } from '../../utils/NFTFormatedData'
import NFTCardButtons from '../Cards/subComponents/NFTCardButtons/NFTCardButtons'
import { DetailCollection, DetailImage, DetailInfo, DetailInfoTitle, DetailSellerCreator, NFTButtonsWrapper, NFTCategory, NFTDescription, NFTDetailContainer, NFTPrice, NFTPriceWrapper, NFTRoyalties, NFTPropertyItem, NFTProperties, NFTSaleHistoryItem, NFTLikeCount } from '../../newComponents/NFTDetail/styles'
import { defaultCollection } from '.'
import { CheckUrl } from '../../utils/CheckUrl'
import NFTTabs from '../../newComponents/NFTTabs'
import INFTSalesList from '../../models/INFTSalesList'
import { ISaleTokenList, SaleTokenList } from '../../data/SaleTokenList'
import Scrollbar from '../../components/Scrollbar'
import useNFTLike from '../../data/useNFTLike'
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from '../../../../utils/cx'
import { loadNFTLikeCounts } from '../../data/useNFTLikeCount'

export interface IBaseDetail extends INFDetailFormatted {
    children: JSX.Element
    properites?: INFTProperties[]
    description?: JSX.Element
    officalCollection?: boolean
    tokenItemName: string
    externalUrl?: string
    customProperties?: JSX.Element[]
    detailItemCustomStyle?: CSSProperties
    saleList: INFTSalesList[]
}

export default function BaseDetail({
    tokenItem,
    collection,
    // account,
    children,
    properites,
    description,
    officalCollection,
    tokenItemName,
    externalUrl,
    customProperties,
    detailItemCustomStyle,
    saleList
}: IBaseDetail) {
    const [priceInfo, setPriceInfo] = useState<IPriceInfo | null>(null)
    useEffect(() => {
        getTokenPrice().then((res: any) => setPriceInfo(res))
    }, [])
    const activeWeb3 = useActiveWeb3React()
    const { chainId } = activeWeb3
    const saleToken = getSaleToken(tokenItem, chainId)
    const tokenID = tokenItem?.tokenId
    const [buyOrRemove, setBuyOrRemove] = useState(false)
    const yts = chainId !== undefined ? YTS[chainId] : YTS[ChainId.BOBA]
    const boba = chainId !== undefined ? BOBA[chainId] : BOBA[ChainId.BOBA]
    const [removeModalIsOpen, setRemoveModalIsOpen] = useState(false)
    const NFTTokenPrice: string = useGetNFTPrice(tokenItem?.price, yts, true)
    const saleTokenItem = useGetSaleTokenItem(saleToken)
    const { action, isLiked, likeCount, actionTitle } = useNFTLike(collection.tokenAddress.toLowerCase(), tokenID);

    React.useEffect(() => {
        if (collection && tokenID) {
            loadNFTLikeCounts([{
                collectionAddress: collection.tokenAddress.toLowerCase(),
                tokenID: tokenID
            }]);
        }
    }, [tokenID, collection]);

    const userAccountAddress = activeWeb3.account ? activeWeb3.account.toLowerCase() : ''
    const ownerWalletAddress =
        tokenItem && tokenItem.seller && tokenItem.seller.toLowerCase() !== userAccountAddress ? tokenItem.seller : 'wallet'

    const tokenCreators = useGetCreators(tokenID)
    let creatorWalletAddress =
        collection.creatorAddress.toLowerCase() !== userAccountAddress ? collection.creatorAddress : 'wallet'

    if (collection.creatorAddress === '') {
        creatorWalletAddress = tokenCreators.toLowerCase() !== userAccountAddress ? tokenCreators : 'wallet'
    }

    let tokenRoyalities = useGetCreatorFeeRate(tokenID)

    if (collection.tokenAddress.toLowerCase() !== defaultCollection.tokenAddress.toLowerCase()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tokenRoyalities = useGetYetiswapMarketCreatorRate(collection.tokenAddress)
    }

    let fiatPrice: number | null = null

    if (priceInfo && tokenItem && tokenItem.price) {
        if (saleTokenItem.symbol === 'YTS') {
            fiatPrice = parseFloat(NFTTokenPrice) * priceInfo.usdPrice
        } else {
            fiatPrice = parseFloat(NFTTokenPrice) * priceInfo.avaxUsdPrice
        }
    }

    const addPopup = useAddPopup()
    const { buyNFTCallback } = useBuyNFTToken(tokenItem?.saleIndex)
    const { buyNFTCallbackAvax } = useBuyNFTTokenWithAvax(
        tokenItem?.saleIndex,
        JSBI.BigInt(tokenItem && tokenItem.price ? tokenItem?.price : 0).toString()
    )

    const category: INFTCategory | undefined = CategoryList.find(
        (categoryItem: INFTCategory) => categoryItem.id === parseInt(tokenItem?.category ?? '0', 0)
    )

    console.log(saleTokenItem)
    const [approvalA, approveACallback] = useApproveCallback(
        new TokenAmount(saleTokenItem.symbol === 'YTS' ? yts : boba, JSBI.BigInt(tokenItem && tokenItem.price ? tokenItem?.price : 0)),
        chainId ? MARKET_PLACE_ADDRESS[chainId] : undefined
    )

    function cancelRemoveModal() {
        setRemoveModalIsOpen(false)
    }

    function showRemoveModal() {
        setRemoveModalIsOpen(true)
    }

    function getNFTDescription() {
        if (!description || description.props.children == "") return <>No Description</>
        return (<NFTDescription>{description}</NFTDescription>)
    }

    function getNFTSaleHistory() {
        let saleHistory = saleList.filter((saleItem: INFTSalesList) => saleItem.status.toString() == "2");
        if (saleHistory.length > 0) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {saleHistory.map((s, index) => {
                        const _price: string = getNFTPrice(s.price, yts, true)
                        let token = SaleTokenList.find(
                            (item: ISaleTokenList) => item[chainId ? chainId : ChainId.BOBA].toLowerCase() === s.saleToken?.toLowerCase()
                        ) || SaleTokenList[0];

                        return (
                            <NFTSaleHistoryItem key={`sale_${index}`} >
                                <span>{new Date(parseInt((s.insertDate + "000"))).toLocaleDateString()}</span>
                                <div>{'Sold for '} {_price}<NFTPriceSymbol symbol={token.name} image={token.image} /></div>
                            </NFTSaleHistoryItem>
                        )
                    })}
                </div>
            )
        }
        return <>No Sale History</>
    }

    function getNFTProperties() {
        if (!externalUrl && !customProperties && !properites?.filter((attrItem: INFTProperties) => attrItem.value).length) return <>No Properties</>;
        return (
            <NFTProperties>
                {externalUrl &&
                    <NFTPropertyItem key={`EXTERNAL_URL`} className={"hasURL"} onClick={() => {
                        if (CheckUrl(externalUrl))
                            window.open(externalUrl)
                    }}>
                        <span>External Url</span>
                        <div title={externalUrl}>{externalUrl}</div>
                    </NFTPropertyItem>
                }
                {customProperties ? customProperties : properites?.filter((attrItem: INFTProperties) => attrItem.value).map((attrItem: INFTProperties, index: number) => {
                    if (attrItem.isUrl) {
                        return (
                            <NFTPropertyItem key={`${attrItem.key}_TRAIT_TYPE_${index}`} className={"hasURL"} onClick={() => {
                                if (CheckUrl(attrItem.value))
                                    window.open(attrItem.value)
                            }}>
                                <span>{attrItem.key}</span>
                                <div title={attrItem.value}>{attrItem.value}</div>
                            </NFTPropertyItem>
                        )
                    } else if (attrItem.isAudio) {
                        return (
                            <NFTPropertyItem key={`${attrItem.key}_TRAIT_TYPE_${index}`}>
                                <span>{attrItem.key}</span>
                                <div title={attrItem.value}>{attrItem.value}</div>
                                <NFTPlayAudio src={attrItem.value} />
                            </NFTPropertyItem>
                        )
                    } else {
                        return (
                            <NFTPropertyItem key={`${attrItem.key}_TRAIT_TYPE_${index}`}>
                                <span>{attrItem.key}</span>
                                <div>{attrItem.value}</div>
                            </NFTPropertyItem>
                        )
                    }
                })}
            </NFTProperties>
        )
    }

    function buyNowFunction() {
        if (tokenItem?.saleToken !== ZERO_ADDRESS) {
            if (buyNFTCallback) {
                buyNFTCallback()
                    .then((r: any) => {
                        if (r && r.code !== 4001) {
                            setTimeout(() => setBuyOrRemove(true), 2000)
                        }
                    })
                    .catch((e: any) => {
                        console.log(e)
                        const result = NFTBuyCallBackHandle(e, false)
                        addPopup(result, '')
                    })
            }
        } else {
            if (buyNFTCallbackAvax) {
                buyNFTCallbackAvax()
                    .then((r: any) => {
                        if (r && r.code !== 4001) {
                            setTimeout(() => setBuyOrRemove(true), 2000)
                        }
                    })
                    .catch((e: any) => {
                        const result = NFTBuyCallBackHandle(e, false)
                        console.log(e)
                        addPopup(result, '')
                    })
            }
        }
    }

    const renderTabContent = (key: string) => {
        switch (key) {
            case 'description':
                return getNFTDescription();
            case 'properties':
                return getNFTProperties();
            case 'saleHistory':
                return getNFTSaleHistory();
            default:
                return <></>;
        }
    }

    return (
        <Scrollbar width={"80%"}>
            <NFTDetailContainer>
                <DetailImage style={detailItemCustomStyle}>
                    {children}
                </DetailImage>
                <DetailInfo>
                    <DetailInfoTitle>{tokenItemName}</DetailInfoTitle>
                    {officalCollection !== false && (
                        <DetailCollection
                            className="collection-link"
                            to={`/collection/${collection.tokenAddress}`}
                            title={`${collection.name} Verified Collection`}
                        >
                            {collection.forkProject && (
                                <ForkIcon width="1.2rem" height="1.2rem" className="form-icon" title="Forked Collection" />
                            )}
                            {collection.oldProject && (
                                <AlertIcon width="1.2rem" height="1.2rem" className="form-icon" title="Old Project, You need to migrate new version" />
                            )}
                            <VerifiedIcon className="verified-icon" width="1.5rem" /> {collection.name}
                        </DetailCollection>
                    )}
                    <NFTLikeCount className={cx({ liked: isLiked })} title={actionTitle} onClick={action}>
                        <FontAwesomeIcon icon={faHeart} size={"1x"} />
                        {likeCount > 0 && <span>{likeCount}</span>}
                    </NFTLikeCount>
                    {category && category.id != 0 && <NFTCategory>{category.name}</NFTCategory>}
                    <DetailSellerCreator>
                        <NFTUserInfoCompact accountAddress={tokenItem.seller} currentAccountAdress={null} label='Seller' addressSlice={8} redirectToLink='/profile/{{address}}?tab=on-sale' />
                        <NFTUserInfoCompact accountAddress={creatorWalletAddress} currentAccountAdress={userAccountAddress} label="Creator" addressSlice={8} redirectToLink='/profile/{{address}}?tab=on-sale' />
                    </DetailSellerCreator>
                    {NFTTokenPrice !== '0' && (
                        <NFTPriceWrapper>
                            <NFTPrice>
                                <span>Price:</span>
                                <div>
                                    {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
                                </div>
                                {fiatPrice && <div>(~{fiatPrice.toFixed(2)} USD)</div>}
                            </NFTPrice>
                            {tokenRoyalities ?
                                <NFTRoyalties>
                                    <span>Royalties: </span>
                                    <div>{tokenRoyalities}%</div>
                                </NFTRoyalties>
                                : ""
                            }

                        </NFTPriceWrapper>
                    )}
                    <NFTButtonsWrapper>
                        <NFTCardButtons
                            tokenId={tokenItem?.tokenId}
                            tokenContractAddress={collection.tokenAddress}
                            tokenName={tokenItemName}
                            approve={approveACallback}
                            approveState={approvalA}
                            buyNow={buyNowFunction}
                            isSale={NFTTokenPrice !== '0'}
                            token={tokenItem}
                            removeSale={showRemoveModal}
                            saleToken={saleToken}
                            priceInfo={priceInfo}
                        />
                    </NFTButtonsWrapper>
                </DetailInfo>

                <NFTRemoveModal
                    isOpen={removeModalIsOpen}
                    onDismiss={cancelRemoveModal}
                    tokenId={tokenItem && tokenItem.saleIndex ? tokenItem.saleIndex : 0}
                    NFTName={tokenItemName}
                    getSalesNFTItems={() => setBuyOrRemove(true)}
                    key={`${tokenItem?.id}_${collection.tokenAddress}_MODAL`}
                />
                {buyOrRemove && <Redirect to={`/profile/wallet?tab=collection`} />}
            </NFTDetailContainer>
            <div style={{ height: 400, marginTop: '1rem', width: '100%', padding: '0 15%' }}>
                <NFTTabs tabs={[{ key: "description", name: 'Description' }, { key: "properties", name: 'Properties' }, { key: "saleHistory", name: 'Sale History' }]} renderTabContent={renderTabContent} />
            </div>
        </Scrollbar>
    )

    // return (
    //     <NFTDetailItemWrapper>
    //         <NFTDetailItem style={detailItemCustomStyle}>{children}</NFTDetailItem>
    //         <NFTDetailItemMeta>
    //             <div className="meta-details">
    //                 {officalCollection !== false && (
    //                     <NavLink
    //                         className="collection-link"
    //                         to={`/collection/${collection.tokenAddress}`}
    //                         title={`${collection.name} Verified Collection`}
    //                     >
    //                         {collection.forkProject && (
    //                             <ForkIcon width="1.2rem" height="1.2rem" className="form-icon" title="Forked Collection" />
    //                         )}
    //                         {collection.oldProject && (
    //                             <AlertIcon width="1.2rem" height="1.2rem" className="form-icon" title="Old Project, You need to migrate new version" />
    //                         )}
    //                         <VerifiedIcon className="verified-icon" width="1.5rem" /> {collection.name}
    //                     </NavLink>
    //                 )}
    //                 <div className="detail-head">
    //                     <div className="title">{tokenItemName}</div>
    //                     <NFTDetailActions tokenPrice={NFTTokenPrice} seller={ownerWalletAddress} creator={creatorWalletAddress} />
    //                 </div>
    //                 {category && (
    //                     <div className="category">
    //                         <NFTCategoryButton text={category.name} />
    //                     </div>
    //                 )}
    //                 {NFTTokenPrice !== '0' && (
    //                     <div className="price">
    //                         <div className="tokenPrice">
    //                             {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
    //                         </div>
    //                         {fiatPrice && <div className="fiat-price">(${fiatPrice?.toFixed(2)})</div>}
    //                     </div>
    //                 )}
    //                 <div className="owner">
    //                     Owned by{': '}
    //                     {tokenItem ? (
    //                         <NavLink to={`/profile/${ownerWalletAddress}?tab=on-sale`}>
    //                             <NFTUserInfoCompact accountAddress={tokenItem.seller} currentAccountAdress={userAccountAddress} />
    //                             {/* {ownerWalletAddress === 'wallet' ? 'You' : getWalletAddress(tokenItem.seller)} */}
    //                         </NavLink>
    //                     ) : (
    //                         ''
    //                     )}
    //                 </div>
    //                 <div className="creator">
    //                     Created by{': '}

    //                     {tokenItem ? (
    //                         <NavLink to={`/profile/${creatorWalletAddress}?tab=on-sale`}>
    //                             <NFTUserInfoCompact accountAddress={creatorWalletAddress} currentAccountAdress={userAccountAddress} />
    //                             {/* {creatorWalletAddress === 'wallet' ? 'You' : getWalletAddress(creatorWalletAddress)} */}
    //                         </NavLink>
    //                     ) : (
    //                         ''
    //                     )}

    //                 </div>
    //                 {tokenRoyalities ? (
    //                     <div className="token-royalties">
    //                         Royalties : <span>{tokenRoyalities}%</span>
    //                     </div>
    //                 ) : (
    //                     ''
    //                 )}
    //                 {getNFTDescription()}
    //                 {getNFTProperties()}
    //             </div>
    //             <NFTCardButtons
    //                 tokenId={tokenItem?.tokenId}
    //                 tokenContractAddress={collection.tokenAddress}
    //                 tokenName={tokenItemName}
    //                 approve={approveACallback}
    //                 approveState={approvalA}
    //                 buyNow={buyNowFunction}
    //                 isSale={NFTTokenPrice !== '0'}
    //                 token={tokenItem}
    //                 removeSale={showRemoveModal}
    //                 // account={account}
    //                 saleToken={saleToken}
    //                 priceInfo={priceInfo}
    //             />
    //         </NFTDetailItemMeta>
    //         <NFTRemoveModal
    //             isOpen={removeModalIsOpen}
    //             onDismiss={cancelRemoveModal}
    //             tokenId={tokenItem && tokenItem.saleIndex ? tokenItem.saleIndex : 0}
    //             NFTName={tokenItemName}
    //             getSalesNFTItems={() => setBuyOrRemove(true)}
    //             key={`${tokenItem?.id}_${collection.tokenAddress}_MODAL`}
    //         />
    //         {buyOrRemove && <Redirect to={`/profile/wallet?tab=collection`} />}
    //     </NFTDetailItemWrapper>
    // )
}
